import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4maps from "@amcharts/amcharts4/maps";
import am4geodata_worldLow from "@amcharts/amcharts4-geodata/worldLow";
import am4geodata_continentsLow from "@amcharts/amcharts4-geodata/continentsLow";
import am4geodata_data_countries2 from "@amcharts/amcharts4-geodata/data/countries2";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import Sidebar from "../sidebar/sidebar.component";
import MapFilters from "../map-filters/map-filters.component";
import { mergeById, removeDuplicate, findCountryByEventId, findEndMarkerCoordinates } from "../../Utility/utils"
import Service from '../../Service/apiREST';
import TableEvents from "../table-events/table-events.component";
import Row from "../Row";
import {Decimal} from 'decimal.js';
import PinEventImg from '../../assets/img/pin_event.png';
import PinManuscriptsImg from '../../assets/img/manuscript.png';
import PinEndPoint from '../../assets/img/endPoint.png'
import ManuscriptHoverImg from "../../assets/img/manuscript_hover.png";
import PinEarthquakeImg from '../../assets/img/earthquake.svg';
import PinFloodImg from '../../assets/img/flood.svg';
import PinEruptionImg from '../../assets/img/eruption.svg';
import PinHurricaneImg from '../../assets/img/hurricane.svg';
import DateFilters from "../filters/DateFilters";
import swal from '@sweetalert/with-react';
import '../../Components/database/directorydatabase/alertbutton.styles.css'
// ** Store & Actions
import { useDispatch, useSelector } from 'react-redux'
import { setSelectedCountry } from '../../redux/map'
import * as am4plugins_overlapBuster from "@amcharts/amcharts4/plugins/overlapBuster";

//MARK: Please, install the following dependencies: npm install @amcharts/amcharts4 and npm install @amcharts/amcharts4-geodata
 
// 1) Quando il sito è caricato,
// 2) viene richiamata la useEffect che inizializza la mappa.
// 3) è richiamata in seguito la useFetch che effettuala chiamata ajax.
// 4) Quando la chiamata ajax ha i dati di risposta, aggiorna la mappa con i dati ricevuti dal server.
 
 
 
function MapSection(props) {
 
  /** ========= React HOOK =========== */
  const [filtersData, setFiltersData] = useState([])
  const [error, setError] = useState(null);
  const [isLoaded, setLoaded] = useState(false);
  const [filterButton, setFilterButton] = useState(false);
  const [mostra, setMostra] = useState(false)
  const [country, setCountry] = useState('');
  const [countrySelected, setCountrySelected] = useState('');
  const [data, setData] = useState([]);
  const [showEventsTable, setShowEventsTable] = useState(true);
  const [showFilters, setShowFilters] = useState(true)
  const [dateFiltersData, setDateFiltersData] = useState([])
  const [fromDate, setFromDate] = useState("")
  const [toDate, setToDate] = useState("")
  const [pinSelected, setPinSelected] = useState('')
  const [eventId, setEventId] = useState([])
  const [show, setShow] = useState(false);
  const [showCard, setShowCard] = useState(true)
  const [showDateFilters, setShowDateFilters] = useState(false)
  const [eventPlace, setEventPlace] = useState([])
  const [dataLat, setDataLat] = useState([])
  const [dataLong, setDataLong] = useState([])
  const [isFiltered, setIsFiltered] = useState(false)
  const [screenView, setScreenView] = useState('')
   
  /** ========= React HOOK =========== */

   // ** Store Vars
   const dispatch = useDispatch();
   const store = useSelector(state => state.map)

  /** =============== REFERENCE ===============*/
  const originalDataRef = useRef(null);
  const homeRef = useRef(null);
  const worldseriesRef = useRef(null);
  const countryseriesRef = useRef(null);
  const continentsSeriesRef = useRef(null);
  const imageseriesRef = useRef(null);
  const imageseriesBulletsRef = useRef(null);
  const eventsRef = useRef(null);
  const countryEnabledRef = useRef(null);
  const manuscriptDataRef = useRef(null);
  const lineSeriesRef = useRef(null);
  const manuscriptStartCoordinateRef = useRef([]);
  const manuscriptCoordinatesRef = useRef([]);
  const markersRef = useRef([]);
  const countryDataRef = useRef(null);
  const selectedCountryRef = useRef(null);
  const selectedPinRef = useRef(null)
  const pinEnabledRef = useRef(null)
  /** =============== REFERENCE ===============*/


  // Ajax call
  useEffect(() => {
    getMapData();
  }, []);

  const fromChildToParent = (childData)=> {
    setDateFiltersData(childData)
    var tempArray = []
    childData.forEach(element => {
     var tempElement = {
        eventId: element.id,
        fill: am4core.color("#A92820"),
        id: element.nationISO,
        latitude: element.epicenterLat,
        longitude: element.epicenterLng,
        markerPin: element.place,
        value: element.eventDate,
        eventType: element.eventType,
        date: element.eventDate,
        white: am4core.color("#FFFFFF"),
        event: getMarkersSvg(element.eventType.toLowerCase()) 
      }
      tempArray.push(tempElement)
      
    });

    showMarkerOnCountry(tempArray) 
  }

 
  //####--------- Function => When we click on the NEWS CIRCULATION MAP-------------#################
  const setEventDocumentMap = () => {
 
    // 1. hide countries
    countryseriesRef.current.hide();
 
    // 2. Back home position again
    homeRef.current.goHome();
 
    // 3. Show the world again
    worldseriesRef.current.show();
 
    // continentsSeriesRef.current.show();
    setFilterButton(false);
    setMostra(true)
    setShowDateFilters(false)

    const country = findCountryByEventId(eventsRef.current, manuscriptDataRef.current[0].eventRecord['id']);
    worldseriesRef.current.mapPolygons.each((polygon, index) => {
      polygon.fill = am4core.color("#D8D8D8")
      polygon.events.disable();
 
    })
 
 
    // Zoom-out is set to 6.
    homeRef.current.zoomToMapObject(worldseriesRef.current.getPolygonById(country), 8, true);
    homeRef.current.events.disable();

    showBlackLinesAgain()


    showManuscripts(markersRef.current);  
  }
 
 const showBlackLinesAgain = () => {
  removeAllMapLineSeries()
  setDataLat(null)
  setDataLong(null)
 setMostra(true)
  manuscriptCoordinatesRef.current = getMarkerPointFromManuscript();
  
 
  //Coordinates + image of the Manuscript
  markersRef.current = manuscriptCoordinatesRef.current.reduce((acc, curr) => {
    acc.push({ latitude: curr.latStart.toNumber(), longitude: curr.lngStart.toNumber(), event: PinManuscriptsImg });
    acc.push({ latitude: curr.latEnd.toNumber(), longitude: curr.lngEnd.toNumber(), event: PinEndPoint});

    //In this ref, we store the values of the array
    manuscriptStartCoordinateRef.current.push({ latitude: curr.latStart, longitude: curr.lngStart, event: PinEndPoint });
    return acc;
  }, []);

  // Connection between the lat & lng
  let pathCoordinate = manuscriptCoordinatesRef.current.map((coordinate) => {
    var x = [];
    x.push({ latitude: coordinate.latStart.toNumber(), longitude: coordinate.lngStart.toNumber() });
    x.push({ latitude: coordinate.latEnd.toNumber(), longitude: coordinate.lngEnd.toNumber() });
    return x;
  });

  // Create the line to connect the cities   
  pathCoordinate.map((el, idx) => {
    let line = createLineSeries('myLine_' + idx);
    let arrow = line.arrow;
    arrow.width = 12
    arrow.height= 12
    arrow.position = 1;
    arrow.nonScaling = true;


  // The line is associated to the pathCoordinate
    line.multiGeoLine = [el];

 })
}


  //when we click on the X (close the Sidebar)
  const handleClick = () => {
   // worldseriesRef.current.data = originalDataRef.current;
   // worldseriesRef.current.show();
   // continentsSeriesRef.current.show();
   // countryseriesRef.current.hide();
   // homeRef.current.goHome();

    setFilterButton(false);
    setMostra(false)
    removeAllMapLineSeries();
    //showMarkerOnCountry(null)
    //setShowEventsTable(true);
    setShowFilters(false)
    setShowDateFilters(false)
    setCountrySelected("")
    setFromDate("")
    setToDate("")
    setDateFiltersData([])
    
    //this will remove the circles
    imageseriesBulletsRef.current.data = null;
  }
 
  const handleFiltersData = (data) => {
    setFiltersData(data)
  }
 
  const isCountryEnabled = (country) => {
    return countryEnabledRef.current.includes(country);
  };
 
  //####--------- MARKER FROM THE MANUSCRIPT ---------#############
  const getMarkerPointFromManuscript = () => {
    let markers = manuscriptDataRef.current.map(event => {
   
      return {
        "latStart": new Decimal(event.latStart),
        "lngStart": new Decimal(event.lngStart),
        "latEnd": new Decimal(event.latEnd),
        "lngEnd": new Decimal(event.lngEnd),
        "event": PinManuscriptsImg
      }
    });
    return markers;
  }
  //####--------- MARKER FROM THE COUNTRY---------#############
  const getMarkerPointFromCountry = (country) => {
    var markers = eventsRef.current.filter(event => {
      if (event.id === country) {
        return {
          "latitude": new Decimal(event.latitude).toNumber(),
          "longitude": new Decimal(event.longitude).toNumber()
        } 
      }
    });
    return markers;
  }

  // Function in order to associate the different images of the pins
const getMarkersSvg = eventType => {
    const eventSVG = {
      'event': PinEventImg, 
      'earthquake': PinEarthquakeImg, 
      'flood': PinFloodImg, 
      'eruption': PinEruptionImg, 
      'hurricane': PinHurricaneImg,
      'manuscript': PinManuscriptsImg 
    };
    return eventSVG.hasOwnProperty(eventType) ? eventSVG[eventType] : '';
  }
 
  // All the Map data =>
  useLayoutEffect(() => {

    localStorage.removeItem('view')
    // Themes begin -> We load the library
    am4core.useTheme(am4themes_animated);
    // am4core.options.autoSetClassName = false;
    // Themes end
 //setShowDateFilters(true)
    // Create map instance
    let chart = am4core.create("chartdiv", am4maps.MapChart);
    chart.projection = new am4maps.projections.Miller();
 
    let continentsSeries = chart.series.push(new am4maps.MapPolygonSeries());
    continentsSeries.geodata = am4geodata_continentsLow;
    continentsSeries.exclude = ["antarctica"]

    // Create map polygon series for world map
    let worldSeries = chart.series.push(new am4maps.MapPolygonSeries());
    worldSeries.useGeodata = true;
    worldSeries.geodata = am4geodata_worldLow;
    worldSeries.exclude = ["AQ"];
    worldSeries.calculateVisualCenter = true;
    worldSeries.tooltip.label.interactionsEnabled = true;
    worldSeries.tooltip.keepTargetHover = true;
 
    let worldPolygon = worldSeries.mapPolygons.template;
    worldPolygon.tooltipPosition = "fixed";
    worldPolygon.strokeWidth = 0;
    worldPolygon.fill = am4core.color("#D3D3D3");
    worldPolygon.propertyFields.fill = "fill";
    //Set the Tooltip 
    worldPolygon.tooltipText = "{name}"
  

    
    // Create hover state and set alternative fill color
    //let hsw = worldPolygon.states.create("hover"); <- questo è l'hover
    //hsw.properties.fill = am4core.color("#DC251A");
    let colorSet = new am4core.ColorSet();
 
    // Create country specific series (but hide it for now)
    let countrySeries = chart.series.push(new am4maps.MapPolygonSeries());
    countrySeries.useGeodata = true;
 
    // Setting per i bordo delle singole regioni di una nazione
    countrySeries.mapPolygons.template.fillOpacity = 1;
    // larghezza delle linee di confine
    countrySeries.mapPolygons.template.strokeWidth = 0;
    // colore delle linee
    // countrySeries.mapPolygons.template.stroke = am4core.color("#ffffff");
    // se si vuole interagire con le regioni, al click performano azioni
    countrySeries.mapPolygons.template.interactionsEnabled = true;
 
    // Hover on the nations with red "events"
    worldPolygon.events.on("over", function (ev) {
      let id = ev.target.dataItem.dataContext.id;
      if (null !== countryEnabledRef.current && countryEnabledRef.current.includes(id)) {
        let hs = ev.target.states.create("hover");
        hs.properties.fill = am4core.color("#DC251A")
      }
    });

   /* chart.events.on("ready", function(ev) {
      chart.zoomToMapObject(worldSeries.getPolygonById("IT"));
    }); */
    chart.events.on("ready", function(ev) {
      if (0 < Object.keys(store.selectedCountryEvent).length) {
       drawSelectedCountry(store.selectedCountryEvent)
      }
    }); 

 
    //Setting the initial zoom view
    chart.homeZoomLevel = 2
    chart.homeGeoPoint = {
      latitude: 12,
      longitude: 9
     };
    //nascondiamo la series con le regioni perchè nel grafico mostriamo solo una serie
    countrySeries.hide();
 
      // handler che si avvia quando clicchiamo su una nazione
    countrySeries.geodataSource.events.on("done", function (ev) {
      // hide the map of the world
      worldSeries.hide();
      // load the countries that belong to the clicked nation
      countrySeries.show();
    });
 
    // setting polygon del country
    let countryPolygon = countrySeries.mapPolygons.template;
    //countryPolygon.tooltipText = "{name}";
    countryPolygon.nonScalingStroke = false;
    //countryPolygon.strokeOpacity = 0.5;
    countryPolygon.fill = am4core.color("#D8D8D8");

    // show all the cards when the nation is clicked.
    countryPolygon.events.on("hit", async(ev) => {
      localStorage.removeItem('view')

      let nationId = ev.target.dataItem.dataContext.id
      var sliceNationId = nationId.slice(0, 2)
      getEventsFromASingleNation(sliceNationId)
  }, this); 

    // inject the worldseries in the chart
    chart.series.push(worldSeries);
    chart.projection = new am4maps.projections.Mercator();
 
    //when you click on a nation, you can set an action to perform  by using this function
    //download from the library the data of the map on click
 
    let imageSeries = chart.series.push(new am4maps.MapImageSeries());
    let imageBulletsSeries = chart.series.push(new am4maps.MapImageSeries());

    worldPolygon.events.on("hit", function (ev) {
     // setShowDateFilters(true)
     localStorage.removeItem('view')
      dispatch(setSelectedCountry(ev.target.dataItem.dataContext))
      selectedCountryRef.current = ev.target;
      continentsSeries.hide();
      ev.target.isHover = false;
      drawSelectedCountry(ev.target.dataItem.dataContext)

    });
 
    chart.zoomControl = new am4maps.ZoomControl();

    worldSeries.events.on('hit', e => {
      
      if(localStorage.getItem('view') && '3' === localStorage.getItem('view')) {
        showBlackLinesAgain()     
      }
    })
 
    //MARK: This button is commented. If it is implemented, it will show the Globe Button in order to zoom out.

    //#---------HOME BUTTON ---------------# 
  /*  let homeButton = new am4core.Button();
      homeButton.events.on("hit", function () {
 
      worldSeries.show();
      countrySeries.hide();
      setFilterButton(false);
      chart.goHome();
      removeAllMapLineSeries();
      showMarkerOnCountry(null, '');
      worldseriesRef.current.data = originalDataRef.current;
      setShowEventsTable(true);
      handleClick()
    });
 
    homeButton.icon = new am4core.Sprite();
    homeButton.padding(7, 5, 7, 5);
    homeButton.width = 30;
    homeButton.icon.path = "M 15 8.097656 C 11.195312 8.097656 8.097656 11.195312 8.097656 15 C 8.097656 18.804688 11.195312 21.902344 15 21.902344 C 18.804688 21.902344 21.902344 18.804688 21.902344 15 C 21.902344 11.195312 18.804688 8.097656 15 8.097656 Z M 14.714844 17.121094 C 14.753906 17.238281 14.414062 17.578125 14.382812 17.597656 C 14.355469 17.617188 13.722656 17.269531 13.617188 17.21875 C 13.507812 17.171875 13.265625 16.382812 13.265625 16.382812 L 13.03125 16.160156 C 13.03125 16.160156 12.496094 15.757812 12.449219 15.738281 C 12.398438 15.71875 12.300781 14.972656 12.269531 14.902344 C 12.238281 14.835938 12.027344 14.621094 11.96875 14.582031 C 11.914062 14.542969 11.882812 13.882812 11.882812 13.882812 C 11.882812 13.882812 11.914062 13.5 12.105469 13.21875 C 12.300781 12.9375 12.292969 12.449219 12.234375 12.351562 C 12.175781 12.257812 11.792969 12.398438 11.792969 12.398438 C 11.792969 12.398438 11.5 12.25 11.46875 12.269531 L 11.273438 11.902344 C 11.273438 11.902344 10.097656 11.820312 10.117188 11.789062 C 10.117188 11.789062 11.988281 8.808594 15.875 9.257812 L 15.945312 9.257812 C 16.152344 9.273438 16.347656 9.273438 16.457031 9.46875 C 16.480469 9.503906 16.875 9.851562 16.867188 9.851562 C 16.863281 9.851562 15.785156 9.851562 15.785156 9.851562 L 15.5625 10.046875 L 16.546875 10.632812 C 16.410156 10.671875 16.136719 10.757812 15.953125 10.816406 C 15.828125 10.855469 15.714844 10.914062 15.609375 10.992188 L 15.222656 11.28125 L 14.859375 11.796875 L 15.386719 12.1875 C 15.386719 12.1875 16 12.65625 16.027344 12.675781 C 16.058594 12.695312 16.183594 12.285156 16.183594 12.285156 C 16.171875 11.96875 16.160156 11.65625 16.144531 11.339844 C 16.242188 11.375 16.339844 11.40625 16.4375 11.4375 L 16.867188 11.398438 C 16.867188 11.398438 17.292969 11.730469 17.34375 11.769531 C 17.390625 11.808594 17.585938 12.226562 17.585938 12.226562 C 17.578125 12.292969 17.535156 12.648438 17.617188 12.664062 C 17.632812 12.664062 17.648438 12.660156 17.664062 12.652344 C 17.8125 12.578125 17.953125 12.496094 18.09375 12.414062 C 18.160156 12.371094 18.304688 12.246094 18.382812 12.246094 C 18.414062 12.246094 18.257812 12.597656 18.238281 12.625 C 18.222656 12.648438 17.859375 13.253906 17.703125 13.515625 C 17.65625 13.59375 17.601562 13.660156 17.539062 13.726562 L 17.03125 14.242188 L 17.207031 14.542969 L 16.78125 15.042969 C 16.746094 15.085938 16.707031 15.125 16.667969 15.164062 L 16.214844 15.566406 C 16.214844 15.566406 15.71875 15.683594 15.6875 15.683594 C 15.660156 15.683594 15.289062 15.769531 15.289062 15.769531 C 15.289062 15.769531 14.589844 15.699219 14.492188 16.070312 C 14.394531 16.441406 14.675781 17.003906 14.714844 17.121094 Z M 19.882812 15.316406 C 19.972656 15.296875 19.648438 15.730469 19.628906 15.796875 C 19.609375 15.867188 19.273438 16.210938 19.273438 16.210938 L 18.722656 16.28125 C 18.8125 15.765625 19.238281 15.378906 19.757812 15.332031 C 19.820312 15.324219 19.867188 15.320312 19.882812 15.316406 Z M 16.753906 17.046875 L 16.496094 16.664062 C 16.472656 16.632812 16.597656 16.5 16.597656 16.5 C 16.597656 16.5 17.578125 16.355469 17.671875 16.363281 C 17.765625 16.375 17.917969 16.664062 17.917969 16.664062 C 17.917969 16.664062 17.578125 17.109375 17.464844 17.109375 C 17.351562 17.109375 16.753906 17.046875 16.753906 17.046875 Z M 17.011719 18.386719 C 17.011719 18.386719 16.894531 18.433594 16.777344 18.492188 C 16.660156 18.550781 16.511719 18.601562 16.492188 18.5625 C 16.472656 18.523438 16.382812 18.464844 16.226562 18.34375 C 16.070312 18.226562 15.863281 18.121094 15.753906 18.070312 C 15.644531 18.019531 15.402344 17.835938 15.359375 17.746094 C 15.335938 17.6875 15.460938 17.519531 15.480469 17.429688 C 15.5 17.34375 15.46875 17.078125 15.527344 17.109375 C 15.585938 17.136719 15.714844 17.058594 15.84375 17.109375 C 15.972656 17.15625 16.167969 17.253906 16.207031 17.332031 C 16.246094 17.410156 16.34375 17.589844 16.453125 17.65625 C 16.5625 17.726562 16.757812 17.804688 16.746094 17.933594 C 16.738281 18.058594 16.894531 18.226562 16.894531 18.226562 Z M 17.207031 20.226562 C 16.667969 19.988281 16.535156 19.71875 16.578125 19.667969 C 16.617188 19.617188 16.957031 19.335938 17.0625 19.191406 C 17.164062 19.046875 17.703125 18.4375 17.703125 18.4375 L 17.535156 18.109375 L 18 17.835938 C 18.144531 17.75 18.304688 17.699219 18.472656 17.679688 L 18.921875 17.636719 C 18.949219 17.636719 18.976562 17.632812 19 17.632812 L 19.726562 17.613281 C 19.726562 17.613281 20.382812 17.441406 20.28125 17.625 C 18.773438 20.34375 17.207031 20.226562 17.207031 20.226562 Z M 17.207031 20.226562";
    homeButton.marginBottom = 10;
    homeButton.parent = chart.zoomControl;
    homeButton.insertBefore(chart.zoomControl.plusButton); */
    //#---------HOME BUTTON ---------------# 
 
    homeRef.current = chart;
    worldseriesRef.current = worldSeries;
    countryseriesRef.current = countrySeries;
    continentsSeriesRef.current = continentsSeries;
    imageseriesRef.current = imageSeries;
    imageseriesBulletsRef.current = imageBulletsSeries;
 
    return () => {
      chart.dispose();
    };
  }, []);

  // This function will set up the Markers on the Mup.
  const setMarkersOnMap = data => {
    if(null !== data) {
      imageseriesRef.current.data = null;
     }
 
     imageseriesRef.current.mapImages.template.events.off('hit');
 
     imageseriesRef.current.mapImages.template.disposeChildren();
     imageseriesRef.current.data = data
 
     // we create the marker
     let imageSeriesTemplate = imageseriesRef.current.mapImages.template;
     imageseriesBulletsRef.current.mapImages.template.disposeChildren();

 //No overlapping pins

 imageSeriesTemplate.layout = "absolute";
 imageSeriesTemplate.isMeasured = true;

 //console.log(homeRef.current.plugins)

 homeRef.current.plugins.pop(new am4plugins_overlapBuster.OverlapBuster())
 
 var overlap = homeRef.current.plugins.push(new am4plugins_overlapBuster.OverlapBuster());
 overlap.targets.push(imageseriesRef.current.mapImages.template);
 overlap.revealRatio = 0.5
 overlap.tolerance = 2
 overlap.collapseDelay = 1000 

  
     imageSeriesTemplate.propertyFields.latitude = "latitude";
     imageSeriesTemplate.propertyFields.longitude = "longitude";
    // imageSeriesTemplate.propertyFields.href = "event";
     // marker translated to the right
     // imageSeriesTemplate.dx = 20;

     
     let marker = imageSeriesTemplate.createChild(am4core.Image);
     marker.width = 50;
     marker.height = 50;
     marker.nonScaling = true;
     //marker.tooltipText = "{title}";
     // marker.tooltipHTML ="<div>{title}</div>";
     marker.horizontalCenter = "middle";
     marker.verticalCenter = "bottom";
     marker.propertyFields.href = "event"
     marker.propertyFields.fill = "white"
     marker.propertyFields.dummyData = "dummyData"
     marker.tooltipText = "{markerPin}'s  {eventType} {date.formatNumber('#')}";

   
     // Ternary operator = country pin or manuscript pin ?
    //marker.href = markerType === 'country' ? PinEventImg : PinManuscriptsImg;
   marker.events.on("hit", async(ev) => {
      
     let pin = ev.target.dataItem.dataContext.eventId
     let nationId = ev.target.dataItem.dataContext.id
     
     const response = await Service.getEventsFromASingleNation(nationId)
   //  getEventsFromASingleNation(nationId)
   setData(response.data.filter((el) => {
      return el.id === pin
     })) 
 
    }) 

  /* marker.events.on("over", async(ev) => {
      let pin = ev.target.dataItem.dataContext.eventId
      let nationId = ev.target.dataItem.dataContext.id
      const response = await Service.getEventsFromASingleNation(nationId)
      getEventsFromASingleNation(nationId)
    }) */

    return {marker: marker, template: imageSeriesTemplate} ;
  }

  /**  This function will show a new icon when we pass the mouse over the icon 
   of the manuscript + if we click on it, it will show the line path related to that manuscript. */
  const showManuscripts = data => {
    const {marker, template} = setMarkersOnMap(data);
    let hs = marker.states.create("hover");
    marker.tooltipText = "{no tooltip}";
    homeRef.current.plugins.pop(new am4plugins_overlapBuster.OverlapBuster())
    hs.properties.href = ManuscriptHoverImg;
    //click event on the pin
    template.events.on('hit', (ev)=> {
      
      localStorage.setItem('view', 3)
      let lat = ev.target.dataItem.dataContext.latitude
      let lng = ev.target.dataItem.dataContext.longitude
   
      setDataLat(lat)
      setDataLong(lng)

      showManuscriptPath(ev)
    setShow(true)
  setShowCard(false)});
  
  }
 
    // Pin on the map
  const showMarkerOnCountry = data => {  
    const {marker} = setMarkersOnMap(data)
  }
  const filterEventType = (data, eventType) => data.filter(el => el.eventType === eventType)
  
  // This function will create the path of the manuscript with the coordinates
  const showManuscriptPath = (ev) => {
    // With this iteration we verify that the pin clicked is the starter point.
    let markerHittedCoord = manuscriptStartCoordinateRef.current.find(coord => { 
      coord.latitude = Decimal.isDecimal(coord.latitude) ? coord.latitude : new Decimal(coord.latitude);
      coord.longitude = Decimal.isDecimal(coord.longitude) ? coord.longitude : new Decimal(coord.longitude);
      return coord.latitude.equals(ev.target.latitude) && coord.longitude.equals(ev.target.longitude)
    });
 
    /* If the starter point is found, the function removeAllMapLineSeries() is called. This will remove
     the mapLineSeries and will recovery the endPoints coordinates according to the Started Pin Point.
    Then we create a new lineSeries and we pass the Id, and then we create the lines.*/
    if (undefined !== markerHittedCoord) {
      removeAllMapLineSeries();
      showMarkerOnCountry(null)
      showManuscripts(markersRef.current);
    
      let endCoordinate = findEndMarkerCoordinates(manuscriptCoordinatesRef.current, markerHittedCoord);
      

      endCoordinate.forEach((coordinates, idx) => {
        let line = createLineSeries(`myLine${idx + 1}`);
        line.stroke = am4core.color("#A92820")
        // Circle at the start point
        let bullet = line.lineObjects.create();
        bullet.position = 0;
        let circle = bullet.createChild(am4core.Circle);
        circle.radius =  0.7;
        circle.fill = am4core.color("#A92820");
        circle.strokeWidth = 0;
        circle.stroke = am4core.color("#A92820");
        //
        let arrow = line.arrow;
        arrow.width = 12
        arrow.height= 12
        arrow.position = 1;
        arrow.nonScaling = true;
        arrow.fill = am4core.color("#A92820"); //red
     
        const startCoordinate = Object.assign({}, markerHittedCoord);
        startCoordinate.latitude = startCoordinate.latitude.toNumber();
        startCoordinate.longitude = startCoordinate.longitude.toNumber();
        endCoordinate.latitude = coordinates.latitude.toNumber();
        endCoordinate.longitude = coordinates.longitude.toNumber();
        
        let pathCoordinate = [startCoordinate, endCoordinate];
        
        line.multiGeoLine = [pathCoordinate];

      })

      
    }
  }
  //this function removes the mapSeriesline.
  const removeAllMapLineSeries = (seriesType = 'MapArcSeries') => {
    let seriesCount = 0;
    let storage = [];
    homeRef.current.series.each((val) => {
      if (seriesType === val.className) {
        // homeRef.current.series.moveValue(val);
        storage.push(val);
        // seriesCount++;
      }
    })

    for (let i = 0; i < storage.length; i++) {
      homeRef.current.series.moveValue(storage[i]);
      homeRef.current.series.pop().dispose();
    }

    // imageseriesRef.current.mapImages.template.disposeChildren();
    //showMarkerOnCountry(null);
 
    // for (let i = 0; i < seriesCount; i++) {
    //   homeRef.current.series.pop().dispose();
    //   showMarkerOnCountry(null, 'manuscript');
    // }
  }
 
  //this function creates the mapSeriesline with the lines.
  const createLineSeries = (id) => {
 
    let lineSeries = homeRef.current.series.push(new am4maps.MapArcSeries());
    lineSeries.mapLines.template.strokeWidth = 4;
    lineSeries.mapLines.template.strokeDasharray = 1;
    lineSeries.mapLines.template.stroke = am4core.color("black");
    lineSeries.mapLines.template.nonScalingStroke = true;
   /* lineSeries.mapLines.template.line.controlPointDistance = -0.9; */
    lineSeries.mapLines.template.line.controlPointPosition = 0.8;
    let line = lineSeries.mapLines.create();
    let bullet = line.lineObjects.create();
    bullet.position = 0;
    let circle = bullet.createChild(am4core.Circle);
    circle.radius = 0.7;
    circle.fill = am4core.color("black");
    circle.strokeWidth = 0;
    circle.stroke = am4core.color("black");
    line.id = id;
    line.setClassName();
 
    return line;
  }
 
  const getMapData = async () => {
 
    let continents = {
      "AF": 0,
      "AN": 1,
      "AS": 2,
      "EU": 3,
      "NA": 4,
      "OC": 5,
      "SA": 6
    }
 
    // Set up data from server, red nations at the beginning
    const response = await Service.getAllEvents();
 
    let serverData = response.data.map(item => {
      let am4CoreObj = {};
      am4CoreObj.id = item.nationISO;
     // è stato commentato per far rilevare la nazione per il tooltip
     // am4CoreObj.name = item.place;
      am4CoreObj.markerPin = item.place;
      am4CoreObj.value = item.eventDate;
      am4CoreObj.date = (item.eventDate)
      am4CoreObj.white = am4core.color("#FFFFFF");
      am4CoreObj.fill = am4core.color("#A92820");
      am4CoreObj.latitude = item.epicenterLat;
      am4CoreObj.longitude = item.epicenterLng;
      am4CoreObj.eventId = item.id
      am4CoreObj.eventType = item.eventType
      am4CoreObj.event = getMarkersSvg(item.eventType.toLowerCase())
      am4CoreObj.dummyData = item.place 
      return am4CoreObj;
      
    });
    
 
    eventsRef.current = serverData;
    countryEnabledRef.current = removeDuplicate(serverData, 'id');
 
    // Set up data for countries
    let data = [];
    for (var id in am4geodata_data_countries2) {
      if (am4geodata_data_countries2.hasOwnProperty(id)) {
        let country = am4geodata_data_countries2[id];
        if (country.maps.length) {
          data.push({
            id: id,
            map: country.maps[0]
          });
        }
      }
    }
 
    let merged = mergeById(data, serverData);
 
    setLoaded(true);
    worldseriesRef.current.data = merged;
    //reset to the original map state.
    originalDataRef.current = merged;
 
  }
  //This function is called when we click on a Nation
  const getEventsFromASingleNation = async (id) => {
    const result = await Service.getEventsFromASingleNation(id)
    setData(result.data);
  }
 // Function for the animated Circle
  const makePulsatingBullet = (coordinates) => {
    imageseriesBulletsRef.current.data = [coordinates];
 
    let imageSeriesTemplate = imageseriesBulletsRef.current.mapImages.template;
 
    imageSeriesTemplate.propertyFields.latitude = "latitude";
    imageSeriesTemplate.propertyFields.longitude = "longitude";
 
    var circle = imageSeriesTemplate.createChild(am4core.Circle);
    circle.radius = 10;
    circle.propertyFields.fill = "color";
    circle.nonScaling = true;
 
    var circle2 = imageSeriesTemplate.createChild(am4core.Circle);
    circle2.radius = 5;
    circle2.fill = "#A92820";
    circle2.fillOpacity = 0.5;
    circle2.stroke = am4core.color("#A92820")
    circle2.nonScaling = false;
    circle2.strokeOpacity = 0.5;
    circle2.events.on("inited", function (event) {
      animateBullet(event.target);
    });
    
  }
 
  const animateBullet = (circle) => {
    var animation = circle.animate([{ property: "scale", from: 1 / homeRef.current.zoomLevel, to: 5 / homeRef.current.zoomLevel }, { property: "opacity", from: 1, to: 0 }], 1000, am4core.ease.circleOut);
    animation.events.on("animationended", function (event) {
      animateBullet(event.target.object);
    })
  }
  const setPulsantBullet = (recordId) => {
    // This function is used to find the records.
    const recordFound = eventsRef.current.find(element => recordId === element.eventId )
    // if in "found" there are the coordinates, we create the animated pulsing.
    if(undefined !== recordFound) { 
      // we pass the lat & lng
      makePulsatingBullet({latitude: recordFound.latitude, longitude: recordFound.longitude, color: am4core.color("#A92820")})
    }
  }
 

  // Click on Event Document Map button.
  const handleEventClick = async (eventId) => {
    const result = await Service.getManuscriptByEventId(eventId)
  setScreenView('View2')
  localStorage.removeItem('view')
    if (result.data.length === 0) {
      swal({
        content: <div style={{ fontFamily: 'Montserrat', fontSize: '12px', paddingTop: '20px' }}>
            <h1 style={{ fontSize: '22px', fontFamily: 'Montserrat', fontWeight: '600', textAlign: 'left', marginBottom: '-15px' }}>ALERT</h1>
            <hr style={{ border: '1px solid #DC251A', marginBottom: '25px' }}></hr>
            <p style={{ textAlign: 'left', marginLeft: '0px', fontSize: '15px' }}>No manuscript found</p>
        </div>,
        button: {
            text: "OK",
            value: true,
            visible: true,
            className: "stylebutton",
            closeModal: true,
        },

    })
    }else{
    setEventId(eventId)
    /* if it's true it will load all the events in the sidebar. If it's false, it will show 
     the dummy table. */
    setShowEventsTable(false);
    manuscriptDataRef.current = result.data;
   
    setEventDocumentMap();
    setPulsantBullet(eventId);
   }
}
  // when we click on the dummy table BACK TO EVENTS
  const handleBackEventButton = () => {
    removeAllMapLineSeries();
    showMarkerOnCountry(null)
    countryseriesRef.current.show();
    worldseriesRef.current.hide();
     countryseriesRef.current.geodataSource.load();
    showMarkerOnCountry(countryDataRef.current);
    setShowEventsTable(true);
    homeRef.current.zoomToMapObject(worldseriesRef.current.getPolygonById(country));

    imageseriesBulletsRef.current.data = null;
   
   setFilterButton(true);
   setShowFilters(true)
   setShowDateFilters(true)
  }

  const drawSelectedCountry = (target) => {
    
    const dataContext = store.selectedCountryEvent;
    //const target = 0 < Object.keys(dataContext).length ? dataContext : eventTarget.dataItem.dataContext;
    
  //  dispatch(setSelectedCountry({}));

    selectedCountryRef.current = target;
      
    let map = target.map;
    let id = target.id;

    homeRef.current.zoomToMapObject(worldseriesRef.current.getPolygonById(id));

    continentsSeriesRef.current.hide();
     
    setCountrySelected(map.substring(0, map.indexOf('Low')));
    
    if (isCountryEnabled(id) && map) {
      setCountry(id)
      // get pin on the map.
      const markPointData = getMarkerPointFromCountry(id);
      countryDataRef.current = markPointData;
      getEventsFromASingleNation(id);
      showMarkerOnCountry(markPointData);
      countryseriesRef.current.geodataSource.url = "https://www.amcharts.com/lib/4/geodata/json/" + map + ".json";
         // fa scattare l'handler 
         countryseriesRef.current.geodataSource.load();
      document.getElementById('btnModal').click();
      setFilterButton(true);
      setShowDateFilters(true)
      setMostra(true);
      setShowFilters(true);
    }
  }

  return (
    //mostra la visualizzazione
    <>
   
      <Sidebar handleClickBack={handleBackEventButton} eventsData={data} handleClick={handleClick} width={500} height={"100vh"} countrySelected={countrySelected} filterButton={filterButton} mostra={mostra} showEventsTable={showEventsTable} showFilters={showFilters} setCountrySelected={setCountrySelected} >
        {
          showEventsTable ? <TableEvents pinSelected={pinSelected} onEventClick={handleEventClick} country={countrySelected} eventsData={data} filtersData={filtersData} dateFiltersData={dateFiltersData} handleClick={handleClick} isFiltered={isFiltered} />
            :
            <Row  handleClick={handleBackEventButton} eventsData={data} eventId={eventId} filtersData={filtersData} dateFiltersData={dateFiltersData} dataLat={dataLat} countrySelected={countrySelected} dataLong={dataLong} setDataLat={setDataLat} setDataLong={setDataLong} setShow={setShow} show={show} setShowCard={setShowCard} showCard={showCard} />
        }
 
      </Sidebar>
      <div className="container-fluid container-map">
        {countrySelected && showDateFilters && <DateFilters data={data} childToParent={fromChildToParent} fromDate={fromDate} setFromDate={setFromDate} toDate={toDate} setToDate={setToDate}  setShowDateFilters={setShowDateFilters} showDateFilters={showDateFilters} setIsFiltered={setIsFiltered} /> }
        <button style={{ display: "none" }} id="btnModal" className="button-map" data-toggle="modal" data-target="#exampleModal3" data-backdrop="false"></button>
        {/**This shows the Dropdown Filter when we click on a Nation. It's removed when we come back home position */}
        {filterButton ? <MapFilters getMarkersSvg={getMarkersSvg} eventsData={data} handleFiltersData={handleFiltersData} dateFilteredData={dateFiltersData} />   : null}
        <div id="chartdiv" style={{ width: "103%", height: "86.0vh" }}>
          
        </div>
 
      </div>
    </>
  );
 
}
 
export default MapSection;
